/* funnel-zoovital.js · Countdown + GA4-CTA-Tracking + Mobile-Sticky-Logik
   Ersetzt die Replo-Runtime. Kein externes Framework nötig. */
(function () {
  "use strict";

  /* ---------- Evergreen-Countdown (per Besucher persistent) ---------- */
  function pad(n) { return String(n).padStart(2, "0"); }

  function initClock(el) {
    var hours = parseFloat(el.getAttribute("data-fz-hours")) || 10;
    var key = "fzCountdown:" + (el.getAttribute("data-fz-key") || "default");
    var span = hours * 3600 * 1000;

    function deadline() {
      var stored = parseInt(localStorage.getItem(key), 10);
      var now = Date.now();
      if (!stored || isNaN(stored) || stored <= now) {
        stored = now + span;
        try { localStorage.setItem(key, String(stored)); } catch (e) {}
      }
      return stored;
    }

    var numH = el.querySelector('[data-fz="h"]');
    var numM = el.querySelector('[data-fz="m"]');
    var numS = el.querySelector('[data-fz="s"]');

    function tick() {
      var diff = Math.max(0, deadline() - Date.now());
      var t = Math.floor(diff / 1000);
      if (numH) numH.textContent = pad(Math.floor(t / 3600));
      if (numM) numM.textContent = pad(Math.floor((t % 3600) / 60));
      if (numS) numS.textContent = pad(t % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- GA4 / dataLayer CTA-Tracking ---------- */
  function initTracking(root) {
    var eventName = root.getAttribute("data-ga4-event") || "funnel_cta_click";
    root.querySelectorAll(".fz__cta").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var payload = {
          cta_position: btn.getAttribute("data-fz-cta") || "unbekannt",
          cta_text: (btn.textContent || "").trim(),
          destination: btn.getAttribute("href") || "",
          page_location: location.pathname
        };
        // dataLayer (GTM/GA4)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, payload));
        // gtag (falls direkt eingebunden)
        if (typeof window.gtag === "function") {
          window.gtag("event", eventName, payload);
        }
      });
    });
  }

  /* ---------- Mobile Sticky-CTA: ausblenden, wenn Offer-CTA sichtbar ---------- */
  function initSticky(root) {
    var sticky = root.querySelector("[data-fz-sticky]");
    var offerCta = root.querySelector('.fz__cta[data-fz-cta="offer"]');
    if (!sticky || !offerCta || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle("is-hidden", e.isIntersecting);
      });
    }, { threshold: 0.1 });
    io.observe(offerCta);
  }

  function boot() {
    document.querySelectorAll("[data-fz-clock]").forEach(initClock);
    document.querySelectorAll(".fz").forEach(function (root) {
      initTracking(root);
      initSticky(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
